import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const basicReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TOGGLE_BUTTON_CLICK:
      return { ...state, ...action.value };
    default:
      return state;
  }
};
export default basicReducer;
